import React, {Component, PropTypes} from 'react'
import StatusAlert from './StatusAlert'
import AppFooter from './AppFooter'
import style from './App.less'

import {connect} from 'react-redux'
import {push} from 'react-router-redux'


function targetOrParentHasHref(node) {
    if (!node || node === document.documentElement) {
        return false
    }
    if (node.hasAttribute('href') && node.nodeName.toLocaleLowerCase() === 'a') {
        return node
    }
    return targetOrParentHasHref(node.parentNode)
}

class App extends Component {
    static propTypes = {
    }

    handleHyperlink = (e) => {
        const {dispatch} = this.props
        const node = targetOrParentHasHref(e.target)
        const href = node && node.getAttribute('href')
        if (href && (/^\/.+/.test(href) && !/^\/static/.test(href) && node.getAttribute('target') !== '_blank')) {
            e.preventDefault()
            dispatch(push(href))
        }
    }

    render() {
    	const {children} = this.props

        return (
            <div onClick={this.handleHyperlink}>
                <StatusAlert />
                {children}
                <AppFooter />
            </div>
        )
    }
}


export default connect()(App)


// WEBPACK FOOTER //
// ./lib/app/components/App.js